import React from 'react';
import { useTranslation } from 'react-i18next';

import SearchIconDetails from 'assets/svg/searchIconDetails.svg';

import { Fade } from '@material-ui/core';

import { TableContainer } from 'app/WMS/styles/styles';

import { Table } from 'components/Tools/Table';

import { StatusContainer, StatusCircle } from '../../styles';

import { IInventoryTableProps, InventoryData } from '../../types';

const InventoryTable: React.FC<IInventoryTableProps> = ({
  rows,
  handleOpenDetailsModal,
}) => {
  const { t } = useTranslation();

  return (
    <Fade in timeout={1000} unmountOnExit>
      <TableContainer>
        <Table<InventoryData>
          columns={[
            {
              title: `Min.`,
              orderable: true,
              type: 'stringCenter',
              display: 'notEmpty',
              cssProps: {
                width: '0.5%',
              },
              props: ['estoqueMinimoAlerta'],
              renderItem: row => {
                const isAlert = row?.estoqueMinimoAlerta || false;

                return (
                  <StatusContainer>
                    <StatusCircle
                      isAlert={isAlert}
                      title={isAlert ? 'Necessidade de compra' : 'OK'}
                    />
                  </StatusContainer>
                );
              },
            },
            {
              title: String(t('screens.commom.deposit')),
              type: 'string',
              orderable: true,
              props: ['deposito'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.reportsStock.address')),
              orderable: true,
              type: 'string',
              props: ['endereco'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.commom.actions')),
              type: 'stringCenter',
              props: ['endereco'],
              cssTitle: {
                width: '0.1%',
                margin: 'auto',
              },
              cssProps: {
                width: '0.1%',
              },
              renderItem: row => (
                <div className="row-actions-button-detail">
                  <button
                    type="button"
                    className="action"
                    onClick={() => handleOpenDetailsModal(row)}
                  >
                    <img
                      src={SearchIconDetails}
                      alt="Detalhes"
                      style={{ width: '30px' }}
                    />
                    <p className="hover-item">{t('screens.commom.details')}</p>
                  </button>
                </div>
              ),
            },
            {
              title: 'EAN',
              orderable: true,
              type: 'string',
              props: ['eans'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: `${t('screens.commom.pallet')}`,
              type: 'string',
              orderable: true,
              display: 'notEmpty',
              props: ['descricaoPalete'],
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.commom.cage')),
              type: 'string',
              orderable: true,
              display: 'notEmpty',
              props: ['gaiola'],
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: `${t('screens.commom.box')}`,
              orderable: true,
              type: 'string',
              props: ['descricaoCaixa'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: `${t('screens.commom.cart')}`,
              type: 'string',
              orderable: true,
              display: 'notEmpty',
              props: ['carrinho'],
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: `${t('screens.commom.shelves')}`,
              orderable: true,
              type: 'string',
              props: ['pratileira'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.commom.product')),
              type: 'string',
              props: ['produto'],
              display: 'notEmpty',
              orderable: true,
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: 'EAN',
              type: 'string',
              props: ['ean'],
              display: 'notEmpty',
              orderable: true,
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.commom.size')),
              orderable: true,
              type: 'string',
              props: ['tamanho'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.manualOrder.operation')),
              orderable: true,
              type: 'string',
              props: ['op'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: `${t('screens.receivement.order')} ${t(
                'screens.commom.sale'
              )}`,
              orderable: true,
              type: 'string',
              props: ['pedidoVenda'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.commom.client')),
              orderable: true,
              type: 'string',
              props: ['cliente'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.transferenceFollowUp.type')),
              orderable: true,
              type: 'string',
              props: ['tipoPedido'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.commom.grid')),
              orderable: true,
              type: 'string',
              props: ['grade'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.commom.color')),
              orderable: true,
              type: 'string',
              props: ['cor'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.reportsStock.descriptionProduct')),
              orderable: true,
              type: 'string',
              props: ['descricaoProduto'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: 'Seller',
              orderable: true,
              type: 'string',
              props: ['seller'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.reportsStock.brand')),
              type: 'string',
              display: 'notEmpty',
              orderable: true,
              props: ['descricaoMarca'],
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.commom.unitMeasure')),
              type: 'string',
              orderable: true,
              props: ['unidadeMedida'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: `${t('screens.receivement.order')}
              ${t('screens.receivement.receivement')}`,
              orderable: true,
              type: 'string',
              props: ['codigoPedido'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: `${t('screens.reportReceipt.batch')} `,
              type: 'string',
              orderable: true,
              display: 'notEmpty',
              props: ['lote'],
              cssProps: {
                width: '5%',
              },
              cssTitle: {
                width: '1%',
              },
            },
            {
              title: `${t('screens.transferenceFollowUp.validity')} `,
              type: 'date',
              orderable: true,
              display: 'notEmpty',
              props: ['validade'],
              cssProps: {
                width: '5%',
              },
              cssTitle: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.commom.stock')),
              type: 'string',
              orderable: true,
              props: ['quantidade'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: `${t('screens.printing.quantity')}
              ${t('screens.reportsStock.reserved')}`,
              type: 'string',
              orderable: true,
              props: ['reservado'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: `${t('screens.printing.quantity')} ${t(
                'screens.reportsStock.available'
              )}`,
              type: 'string',
              orderable: true,
              props: ['disponivel'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: `${t('screens.commom.stock')} KG`,
              type: 'string',
              orderable: true,
              props: ['estoquePeso'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: `${t('screens.commom.branch')} ${t(
                'screens.commom.stock'
              )}`,
              type: 'string',
              orderable: true,
              props: ['depositoErp'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.reportsStock.destinationStore')),
              type: 'string',
              orderable: true,
              props: ['lojaDestino'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.commom.cost')),
              type: 'string',
              orderable: true,
              props: ['custo'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
              renderItem: row => {
                return (
                  <div>
                    <p style={{ marginLeft: '10px' }}>{`R$ ${row.custo}`}</p>
                  </div>
                );
              },
            },
            {
              title: `${t('screens.manualOrder.date')} ${t(
                'screens.address.storage'
              )}`,
              orderable: true,
              type: 'date',
              props: ['dataArmazenagem'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
          ]}
          defaultNumberOfRows={10}
          rows={rows}
          exportList
        />
      </TableContainer>
    </Fade>
  );
};

export default InventoryTable;
